export const solicitacaoReaberturaStatus = {
    EM_ANALISE_PELO_GERENTE: 0,
    EM_ANALISE_PELA_UABS: 1,
    REPROVADA_PELO_GERENTE: 2,
    REPROVADA_PELA_UABS: 3,
    APROVADA: 4,
    CANCELADA: 5
}
